<template>
  <hic-dialog append-to-body @open="open" :close-on-click-modal="false" title="医嘱操作记录" :visible="visible" width="60rem" top="10vh" @close="close">
    <el-container>
      <hic-table :loading="loading" :condition="condition" :entities="entities" style="height: 40rem">
        <el-table-column width="" property="type" label="操作类型" align="center">
          <template slot-scope="{ row }">
            <span class="left-pad primary" v-if="row.type == '下达'">{{ row.type }}</span>
            <span class="left-pad success" v-else-if="row.type == '执行'">{{ row.type }}</span>
            <span class="left-pad danger" v-else-if="row.type == '记账'">{{ row.type }}</span>
            <span class="left-pad warning" v-else-if="row.type == '重启'">{{ row.type }}</span>
            <span class="left-pad warning" v-else-if="row.type == '指示停止'">{{ row.type }}</span>
            <span class="left-pad danger" v-else-if="row.type == '确认停止'">{{ row.type }}</span>
            <span class="left-pad info" v-else>{{ row.type }}</span>
            <el-tag v-if="row.disabled" type="danger" size="mini" hit class="left-pad">后退</el-tag>
            <el-tag v-else-if="row.ifOffset" type="danger" size="mini" hit class="left-pad">冲单</el-tag>
          </template>
        </el-table-column>
        <el-table-column width="" property="state" label="医嘱状态" align="center">
          <template slot-scope="{ row }">
            <div v-if="row.state == '启用'" class="success">{{ row.state }}</div>
            <div v-else-if="row.state == '待校对' || row.state == '待停止'" class="warning">{{ row.state }}</div>
            <div v-else-if="row.state == '停止' || row.state == '取消' || row.state == '退回'" class="danger">{{ row.state }}</div>
            <div v-else class="info">{{ row.state }}</div>
          </template>
        </el-table-column>
        <el-table-column width="" property="execDeptCode" label="操作科室" align="center">
          <template slot-scope="{ row }">
            <div>{{ row.execDeptCode | dictText("Dept") }}</div>
          </template>
        </el-table-column>
        <el-table-column width="" property="executorName" label="操作人" align="center"></el-table-column>
        <el-table-column width="" property="execTime" label="执行时间" align="center">
          <template slot-scope="{ row }">
            <div>{{ row.execTime.substr(0, 16) }}</div>
          </template>
        </el-table-column>
        <el-table-column width="" property="memo" label="备注"></el-table-column>
      </hic-table>
    </el-container>
    <div slot="footer">
      <el-button type="info" size="large" @click.native="$emit('update:visible', false)">关 闭</el-button>
      <el-button v-if="allow" :loading="loading" @click="back" style="margin-right: 1rem" type="danger" size="large">后 退</el-button>
    </div>
  </hic-dialog>
</template>

<script>
  import api from "./api";
  export default {
    components: {},
    props: {
      visible: Boolean,
      advice: Object,
    },
    data() {
      return {
        loading: false,
        entities: {},
        condition: {
          adviceNo: "",
          sort: "id",
          asc: false,
        },
      };
    },
    computed: {
      allow() {
        return this.advice?.state == "启用" || this.advice?.state == "停止" || this.advice?.state == "退回";
      },
    },
    methods: {
      open() {
        this.query();
      },
      query() {
        this.loading = true;
        api.AdviceLog.query({ adviceNo: this.advice.no, sort: "id", asc: false })
          .then((res) => {
            this.entities = res;
          })
          .catch((err) => {
            this.$message.error(err.message || err);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      close() {
        this.$emit("update:visible", false);
      },
      back() {
        this.$confirm("医嘱后退，将取消最近一次对医嘱的操作，是否要执行后退?", "后退医嘱", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.loading = true;
          api.Advice.back(this.advice.id)
            .then((res) => {
              this.$message.success("医嘱已返回到上一步操作");
              this.$emit("backed");
              this.open();
            })
            .catch((err) => {
              this.$message.error(err.message || err);
            })
            .finally(() => {
              this.loading = false;
            });
        });
      },
    },
  };
</script>
